import { defineMessages } from "react-intl";

const BULLET_MESSAGES = defineMessages({
  eventBullet1: {
    id: "hosting.activate_listings.event_item_birthdays",
    defaultMessage: "Birthdays",
  },
  eventBullet2: {
    id: "hosting.activate_listings.event_item_networking",
    defaultMessage: "Networking Event",
  },
  eventBullet3: {
    id: "hosting.activate_listings.event_item_corporate_party",
    defaultMessage: "Corporate Party",
  },
  offSiteBullet1: {
    id: "hosting.activate_listings.off_site_item_workshops",
    defaultMessage: "Workshops",
  },
  offSiteBullet2: {
    id: "hosting.activate_listings.off_site_item_presentations",
    defaultMessage: "Presentations",
  },
  offSiteBullet3: {
    id: "hosting.activate_listings.off_site_item_retreats",
    defaultMessage: "Retreats",
  },
  productionBullet1: {
    id: "hosting.activate_listings.production_item_film_shoots",
    defaultMessage: "Film shoots",
  },
  productionBullet2: {
    id: "hosting.activate_listings.production_item_photo_shoots",
    defaultMessage: "Photo shoots",
  },
  productionBullet3: {
    id: "hosting.activate_listings.production_item_audio_recording",
    defaultMessage: "Audio recording",
  },
});

const BULLETS_BY_USE_TYPE = {
  Event: [
    BULLET_MESSAGES.eventBullet1,
    BULLET_MESSAGES.eventBullet2,
    BULLET_MESSAGES.eventBullet3,
  ],
  "Off-Site": [
    BULLET_MESSAGES.offSiteBullet1,
    BULLET_MESSAGES.offSiteBullet2,
    BULLET_MESSAGES.offSiteBullet3,
  ],
  Production: [
    BULLET_MESSAGES.productionBullet1,
    BULLET_MESSAGES.productionBullet2,
    BULLET_MESSAGES.productionBullet3,
  ],
};

const HEADER_BY_USE_TYPE = defineMessages({
  Event: {
    id: "hosting.activate_listings.event_header",
    defaultMessage: "Events",
  },
  "Off-Site": {
    id: "hosting.activate_listings.off_site_header",
    defaultMessage: "Meetings",
  },
  Production: {
    id: "hosting.activate_listings.production_header",
    defaultMessage: "Media Productions",
  },
});

export { BULLETS_BY_USE_TYPE, HEADER_BY_USE_TYPE };
